export { default } from 'common/enums/type-of-teaching.enum';
